import { Navigate, useParams } from 'react-router-dom'
import useResident from 'hooks/useResident'
import ProfessionalContactForm from '../forms/ProfessionalContactForm'

const ProfessionalContactUpdateScreen = () => {
  const { id, index } = useParams()

  if (!id) {
    return <Navigate to="/residents" />
  }

  const editedIndex = index ? parseInt(index, 10) : undefined

  if (editedIndex && Number.isNaN(editedIndex)) {
    // go to important contacts page
    return <Navigate to="../../" />
  }

  const { isLoading, resident, updateResident } = useResident({ id })

  return (
    <ProfessionalContactForm
      editedIndex={editedIndex}
      onSubmit={updateResident}
      isLoading={isLoading}
      resident={resident}
    />
  )
}

export default ProfessionalContactUpdateScreen
